import { store } from "@src/index";

import { globalActions } from "@features/global/globalSlice";

const loader = async () => {
    const promises = [];
    const ageLevels = store.getState().global.ageLevels;

    !ageLevels.length &&
        promises.push(store.dispatch(globalActions.getAgeLevels()));

    await Promise.all(promises);

    return null;
};

export default loader;
